module.exports = __webpack_public_path__ + "static/media/cpu.be6a1f63.svg";